export const MainColor = '#707070';
